import { z } from 'zod';
import { MenuPriceOptionsSchema } from '../odl/menuPriceOptions';
import { LocalizedStringSchema } from './studio';

export const MenuCatalogItemPatchSchema = z.object({
  id: z.string().uuid().optional(),
  displayOrder: z.number().int().nonnegative().optional(),
  /** Guest-facing dish code (e.g. "12", "N1") for ordering without saying the name. */
  code: z.string().trim().max(32).optional().nullable(),
  name: LocalizedStringSchema,
  description: LocalizedStringSchema.optional(),
  /** Size / portion prices (always ≥1 when priced). Primary amount is options[0].priceCents. */
  priceCents: z.number().int().nonnegative(),
  priceOptions: MenuPriceOptionsSchema.optional().default([]),
  currency: z.string().min(1).default('EUR'),
  dietaryTags: z.array(z.string()).default([]),
  additives: z.array(z.string()).default([]),
  allergens: z.array(z.string()).default([]),
  isAvailable: z.boolean().default(true),
  /** Dish photo URL (path-only `/uploads/…` preferred). Empty string clears. */
  imageUrl: z.string().trim().max(2048).optional().nullable(),
});

export const MenuCatalogCategoryPatchSchema = z.object({
  id: z.string().uuid().optional(),
  displayOrder: z.number().int().nonnegative().optional(),
  title: LocalizedStringSchema,
  /** Category photo URL (path-only `/uploads/…` preferred). Empty string clears. */
  imageUrl: z.string().trim().max(2048).optional().nullable(),
  items: z.array(MenuCatalogItemPatchSchema),
});

export const MenuCatalogTreePatchSchema = z.object({
  name: z.string().min(1),
  categories: z.array(MenuCatalogCategoryPatchSchema),
});
